<template>
  <v-card>
    <v-card-text>
      <v-form ref="weekNavigation">
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12" sm="12" md="2" lg="1">
              <v-btn fab dark small color="primary" @click="refreshList()" :loading="reloading">
                <v-icon dark>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" class="py-1" lg="3" md="4" sm="6">
              <v-autocomplete :no-data-text="$t('message.common.noRecords')" v-model="projectsFilter" :items="listOfProjects"
                item-text="name" item-value="id" hide-details clearable :label="$t('message.timer.selectProjects')" multiple>
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.name }}</span>
                  <span v-if="index === 1" class="grey--text caption">(+{{ projectsFilter.length - 1 }} {{ $t('message.common.others') }})</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="2" sm="2" md="2" lg="1" class="text-right">
              <v-btn fab dark small color="primary" @click="prevWeek">
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="3" sm="2" lg="1">
              <v-text-field :rules="weekValidation" class="pa-0 ma-0" @keypress.enter="goToCustomWeek" v-model="customWeek"></v-text-field>
            </v-col>
            <v-col cols="3" sm="2" lg="1">
              <v-text-field :rules="yearValidation" class="pa-0 ma-0" @keypress.enter="goToCustomWeek"  v-model="customYear"></v-text-field>
            </v-col>
            <v-col cols="2" sm="2" lg="1">
              <v-btn fab small dark color="primary" @click="nextWeek">
                <v-icon dark>mdi-arrow-right</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6" sm="2" lg="1" md="2">
              <v-btn fab small dark color="primary" @click="goToToday">
                <v-icon dark>mdi-calendar</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="3">
              <v-card-title class="pa-0 py-1 custom-size"><span>{{monthName}}</span><span class="pl-5">({{ $t('message.common.weekTotalHours') }}: {{ getWeekTotalHours() }})</span></v-card-title>
            </v-col>
            <v-col cols="6" sm="2" lg="2">
              <v-btn dark color="primary" v-if="activeUser.canDeliverHours" @click="deliverHoursHandler">
                {{ $t('message.timer.deliver') }}
              </v-btn>
            </v-col>
            <!-- <v-col cols="6" sm="2" lg="3" class="pa-0 pb-1">
              <v-card-title class="pa-0 py-1">{{ $t('message.common.weekTotalHours') }}: {{ getWeekTotalHours() }}</v-card-title>
            </v-col> -->
          </v-row>
        </v-container>
      </v-form>
      <v-simple-table class="hourlog-table" fixed-header><!--  height="65vh" -->
        <template v-slot:default>
          <thead class="set-scroll">
            <tr>
              <th width="20%">{{ $t('message.layout.projects') }}</th>
              <th :class="`text-center ${ day.is_today ? 'today_color': ''} ${ day.holiday ? 'holiday_color': ''}`" v-for="(day, index) in listOfDays" :title="day.holiday ? day.holiday.name : ''" :key="index" v-html="`${day.short_day}<br /> ${day.display_date}`"></th>
            </tr>
          </thead>
          <tbody class="set-scroll">
            <template v-for="project in projectsList">
              <tr :key="project.id">
                <v-hover v-slot:default="{ hover }" :key="`${project.id}_unpin`">
                  <td width="20%">
                    <v-btn color="error" v-if="hover && project.noHours && isCurrentWeek" text small fab @click="unCheckSelectedProject(project.id)">
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                    {{ project.name}}
                  </td><!-- {{ project.number }} -  -->
                </v-hover>
                <td v-for="day in project.days" :key="day.date" :class="`text-center ${ day.holiday ? 'holiday_color': ''} ${getStatusColorHandler(day.hours)}`" :title="day.holiday ? day.holiday.name : ''" @click="openFormHandler(project.id, day.date, day.hours, $event)">
                  {{ getHoursSum(day.hours) | replaceDotWithComma }} {{ day.hours && day.hours.length > 1 ? '*' : '' }}
                </td>
              </tr>
            </template>
            <!-- <tr v-for="project in projectsList" :key="project.id">
              <td width="20%">
                <v-btn color="error" text small fab @click="test()">
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
                {{ project.name}}
              </td>{{ project.number }} -
              <td v-for="day in project.days" :key="day.date" :class="`text-center ${ day.holiday ? 'holiday_color': ''} ${getStatusColorHandler(day.hours)}`" :title="day.holiday ? day.holiday.name : ''" @click="openFormHandler(project.id, day.date, day.hours, $event)">
                {{ getHoursSum(day.hours) | replaceDotWithComma }} {{ day.hours && day.hours.length > 1 ? '*' : '' }}
              </td>
            </tr> -->
          </tbody>
          <tbody class="total-hours-row">
            <tr>
              <td colspan="8" class="reduceHeight"></td>
            </tr>
            <tr>
              <td width="20%">{{ $t('message.timer.totalHours') }}</td>
              <td v-for="(total, index) in totalHours" :key="index" :class="`text-center ${ total.holiday ? 'holiday_color': ''}`">
                {{ getHoursSum(total) | replaceDotWithComma }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <!-- Project Form -->
    <v-menu persistent v-model="showNormalHourMenu" top :position-x="positionX" :position-y="positionY" transition="scale-transition"
      :close-on-content-click="false" v-if="$vuetify.breakpoint.mdAndUp">
      <normal-hours v-if="showNormalHourMenu" :hoursOnDay="normalHoursList" class="normal_hours_menu" :hourObj="hourObj" :users="getUsers" :activities="listOfActivities" :currentProjects="selectedProjects"><!-- :worktypes="getWorktypes"  -->
      </normal-hours>
    </v-menu>
    <v-dialog persistent v-model="showNormalHourMenu" width="500" v-else>
      <normal-hours v-if="showNormalHourMenu" :hoursOnDay="normalHoursList" class="normal_hours_menu" :hourObj="hourObj" :users="getUsers" :activities="listOfActivities" :currentProjects="selectedProjects"><!-- :worktypes="getWorktypes"  -->
      </normal-hours>
    </v-dialog>
  </v-card>
</template>
<script>
/* eslint-disable */
import moment from 'moment'
import 'moment/min/locales'
import { mapGetters } from 'vuex'
import NormalHours from './HourTypes/NormalHour'
import CONSTANTS from '@/assets/json/constants.json'
import _localStorage from '@/plugins/local_storage'
export default {
  data () {
    return {
      MODULE: 'hourloggings',
      positionX: 0,
      positionY: 0,
      customWeek: moment().isoWeek(),
      customYear: moment().isoWeekYear(),
      listOfDays: [],
      projectsForComputed: [],
      listOfProjects: [],
      localeLang: 'no',
      startOfWeek: 0,
      endOfWeek: 0,
      totalHours: [],
      listOfHourEntries: [],
      showNormalHourMenu: false,
      normalHoursList: [],
      hourObj: {
        id: 0,
        datePicker: null,
        projectid: null
      },
      monthName: '',
      activeUser: {},
      listOfWorkTypes: [],
      listOfActivities: [],
      reloading: false,
      projectsFilter: [],
      selectedProjects: [],
      isSaveWeekProjects: true,
      isCurrentWeek: false
    }
  },
  components: {
    'normal-hours': NormalHours
  },
  beforeMount () {
    if (this.$i18n.locale === 'no') this.localeLang = 'nb'
    else this.localeLang = 'en'
    var weekNo = +window.localStorage.getItem('stray_vyrje_weekno')
    var year = +window.localStorage.getItem('stray_vyrje_year')
    if (weekNo && year) {
      this.startOfWeek = moment().isoWeekYear(year).isoWeek(weekNo).startOf('isoweek') 
      this.endOfWeek = moment().isoWeekYear(year).isoWeek(weekNo).endOf('isoweek')
    } else {
      this.startOfWeek = moment().isoWeekYear(moment().isoWeekYear()).isoWeek(moment().isoWeek()).startOf('isoweek')
      this.endOfWeek = moment().isoWeekYear(moment().isoWeekYear()).isoWeek(moment().isoWeek()).endOf('isoweek')
      this.setValuesInLocalStorage(moment())
    }
  },
  created () {
    this.$store.dispatch('getHolidays')
    // this.$store.dispatch('getWorktypes')
    this.$store.dispatch('getUsers')
  },
  computed: {
    ...mapGetters(['getHolidays', 'getUsers']),/*  'getWorktypes', */
    loadDays () {
      this.listOfDays = []
      this.loopWeek = this.startOfWeek
      this.customWeek = moment(this.endOfWeek).isoWeek()
      this.isCurrentWeek = moment().week() === this.customWeek
      this.customYear = moment(this.endOfWeek).isoWeekYear()
      let holidaysDates = this.$format.mapDataInArray(this.getHolidays, x => x.date)
      let holidaysName = this.$format.mapDataInArray(this.getHolidays, x => x.en_name) // || x.no_name
      let holidaysData = holidaysDates.map((item, i) => Object.assign({}, {date: item}, {name: holidaysName[i]}))
      for (let i = 1; i <= 7; i++) { //14 for 2 week
        let obj = holidaysData.find(x=> x.date === moment(this.loopWeek).format('YYYY-MM-DDTHH:mm:ss'))
        let loopingDateString = moment(this.loopWeek).format('YYYY-MM-DDTHH:mm:ss')
        this.listOfDays.push({
          'short_day': moment(this.loopWeek).locale(this.localeLang).format('ddd'),
          'date': moment(this.loopWeek).format('DD.MM.YYYY'),
          'display_date': moment(this.loopWeek).format('DD'),
          'monthName': moment(this.loopWeek).locale(this.localeLang).format('MMMM'),
          'is_show': false,
          'is_today': moment(moment(this.loopWeek)).isSame(moment(), 'day'),
          'holiday': obj ? Object.assign({}, obj, {is_holiday:true}) : null
        })
        this.loopWeek = this.startOfWeek.clone().add(i, 'd')
      }
      this.monthName = this.listOfDays[0].monthName
      let lastDateMonthName = this.listOfDays[this.listOfDays.length - 1].monthName
      if (this.listOfDays[0].monthName !== lastDateMonthName) this.monthName += `-${lastDateMonthName}`
      this.setValuesInLocalStorage(moment(this.endOfWeek))
    },
    weekValidation () {
      return [
        val => /^[0-9]+?[0-9]*$/.test(val) || this.$t('message.common.weekNotExists'),
        val => val <= 53 || this.$t('message.common.weekNotExists')
      ]
    },
    yearValidation () {
      return [
        val => /^[0-9]+?[0-9]*$/.test(val) || this.$t('message.common.valid')
      ]
    },
    projectsList: {
      get () {
        let list = this.$format.cloneVariable(this.selectedProjects)
        let listOfHours = this.$format.cloneVariable(this.listOfHourEntries)
        for (let i = 0; i < list.length; i++) {
          list[i].days = this.$format.cloneVariable(this.listOfDays)
          for (let j = 0; j < list[i].days.length; j++) {
            let obj = null
            let hourObj = listOfHours.filter(x => this.$format.formatDate(x.date, 'YYYY.MM.DD', 'DD.MM.YYYY') === list[i].days[j].date && x.projectid === list[i].id)/* x.isSoTask === undefined &&  */
            list[i].days[j].hours = hourObj
          }
          let hours = 0
          list[i].days.forEach(day => {
            hours += this.getHoursSum(day.hours)
          });
          list[i].noHours = true
          if (hours) list[i].noHours = false
        }
        let days = this.$format.cloneVariable(this.listOfDays)
        let totalHours = []
        days.forEach((day, index) => {
            let projects = this.$format.cloneVariable(this.selectedProjects)
            let hoursList = []
            projects.forEach((project,index) => {
              let data = listOfHours.filter(x => this.$format.formatDate(x.date, 'YYYY.MM.DD', 'DD.MM.YYYY') === day.date && x.projectid === project.id )
              if (data && data.length > 0) hoursList = [...hoursList, ...data]
            })
            totalHours[index] = hoursList
        })
        this.totalHours = totalHours
        this.projectsForComputed = list
        return this.projectsForComputed
      },
      set (value) {
        this.projectsForComputed = value
      }
    },
    /* isUnpinnable (project) {
      const days = project.days
      let hours = 0
      days.forEach(day => {
        hours += getHoursSum(day.hours)
      });
    } */
  },
  watch: {
    '$i18n.locale' (val) {
      if (this.$i18n.locale === 'no') this.localeLang = 'nb'
      else this.localeLang = 'en'
      this.loadDays
    },
    'projectsFilter' (val) {
      let selectedProjectIds = this.selectedProjects.map(x => x.id) || []
      selectedProjectIds = [...selectedProjectIds, ...val]
      if (!this.isSaveWeekProjects) return
      this.updateWeekProjects(selectedProjectIds)
      /* this.$cookie.set(CONSTANTS.HOURLOG_FILTER_COOKIE, JSON.stringify(this.projectsFilter))
      this.selectedProjects = this.projectsFilter != null && this.projectsFilter.length > 0 ? this.$format.cloneVariable(this.listOfProjects.filter(x => this.projectsFilter.includes(x.id))) : this.$format.cloneVariable(this.listOfProjects) */
      /* this.getProjectsActivities()
      this.getAllHourEntries() */
    }
  },
  mounted () {
    let getActiveuser = _localStorage.get(process.env.VUE_APP_USER) // this.$cookie.get(process.env.VUE_APP_USER)
    this.activeUser = getActiveuser ? JSON.parse(getActiveuser) : {}
    if (this.activeUser.id) {
      this.activeUser.id = parseInt(this.activeUser.id)
      this.getCurrentUserObj(this.activeUser.id)
    }
    this.loadProjects()
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getWeekprojects()
        //this.getAllHourEntries()
      }
    })

    this.$eventBus.$on('closeForm', () => {
      this.showNormalHourMenu = false
    })

    this.$eventBus.$on('editSingleEntry', (id, isSoTask, worktypeid) => {
      if (isSoTask) {
        let soTask = this.listOfHourEntries.find(x => x.id === id)
        let model = {
          comments: soTask.task,
          date: soTask.date,
          hours: soTask.hours,
          projectid: soTask.projectid,
          projectmemberid: soTask.projectmemberid,
          isSoTask: true,
          soTaskId: soTask.id
        }
        model.worktypeid = soTask.worktype_id ? model.worktype_id : worktypeid
        let transformNumber = { number: { list:['hours', 'findersfee'], format: 'replaceDotWithComma'}}
        model = this.$format.formatModel(model, transformNumber)
        let transformData = { date: { list: ['date'], from: 'YYYY.MM.DD', to: 'DD.MM.YYYY' } }
        model = this.$format.formatModel(model, transformData)
        this.hourObj = model
      } else {
        this.getSingleRecordHandler(id)
      }
    })

    this.$eventBus.$on('getAllHourLogs', () => {
      this.getWeekprojects()
      //this.getAllHourEntries()
    })
  },
  methods: {
    getCurrentUserObj (id) {
      this.$api.execute('get', `users/${id}`)
        .then((response) => {
          let userObj = response.data || {}
          this.activeUser.canDeliverHours = userObj.can_deliver_hours ? userObj.can_deliver_hours : false
        })
    },
    loadProjects () {
      // let date = (this.startOfWeek).format('MM-DD-YYYY')
      this.$api.execute('get', `projects/get_current_projects`) // ?date=${date}
        .then((response) => {
          this.listOfProjects = response.data
          this.getWeekprojects()
          //Load filter from cookie 
          // let filterObject = this.$cookie.get(CONSTANTS.HOURLOG_FILTER_COOKIE)
          /* if(filterObject) {
            this.projectsFilter = JSON.parse(filterObject)
          }else{
            this.selectedProjects = response.data
            this.getProjectsActivities()
            this.getAllHourEntries()
          } */
        })
    },
    refreshList () {
      this.reloading = true
      // this.getWeekprojects()
      this.loadProjects()
      /* this.getProjectsActivities()
      this.getAllHourEntries() */
    },
    getWeekprojects () {
      const week = moment(this.endOfWeek).isoWeek()
      const start = this.$format.formatDate(this.startOfWeek, 'DD.MM.YYYY', 'MM.DD.YYYY')
      const end = moment(this.startOfWeek).add(7,'days'). format('MM.DD.YYYY')
      // const year = moment(this.startOfWeek).year()
      this.$api.execute('get', `weekprojects?year=${this.customYear}&week=${week}&start=${start}&end=${end}`)
        .then((response) => {
          const weekProjects = response.data
          this.isSaveWeekProjects = false
          if (weekProjects.length > 0) {
            const selectedProjectIds = weekProjects.map(x => x.id) || []
            const unSelectedProjects = this.listOfProjects.filter(x => !selectedProjectIds.includes(x.id))
            this.listOfProjects = unSelectedProjects
            this.selectedProjects = this.$format.cloneVariable(weekProjects)// this.projectsFilter.length > 0 ? this.$format.cloneVariable(this.listOfProjects.filter(x => this.projectsFilter.includes(x.id))) : []
          } else {
            this.selectedProjects = []
          }
          this.projectsFilter = []
          this.getProjectsActivities()
          this.getAllHourEntries()
        })
    },
    getProjectsActivities () {
      let ids = this.selectedProjects.map(x => x.id) // change to projectFilter ids
      let model = { ids: ids }
      this.$api.execute('post', '/activities/get_by_project_ids', model)
        .then((response) => {
          this.listOfActivities = response.data
        })
    },
    prevWeek () {
      this.startOfWeek = moment(this.startOfWeek).subtract(1, 'weeks')
      this.endOfWeek = moment(this.endOfWeek).subtract(1, 'weeks')
      this.loadProjects()
      // this.getWeekprojects()
      // this.getAllHourEntries()
    },
    nextWeek () {
      this.startOfWeek = moment(this.startOfWeek).add(1, 'weeks')
      this.endOfWeek = moment(this.endOfWeek).add(1, 'weeks')
      this.loadProjects()
      // this.getWeekprojects()
      // this.getAllHourEntries()
    },
    goToToday () {
      this.startOfWeek = moment().isoWeekYear(moment().isoWeekYear()).isoWeek(moment().isoWeek()).startOf('isoweek')
      this.endOfWeek = moment().isoWeekYear(moment().isoWeekYear()).isoWeek(moment().isoWeek()).endOf('isoweek')
      this.loadProjects()
      // this.getWeekprojects()
      // this.getAllHourEntries()
    },
    goToCustomWeek () {
      if (this.$refs.weekNavigation.validate()) {
        this.startOfWeek = moment().isoWeekYear(+this.customYear).isoWeek(this.customWeek).startOf('isoweek')
        this.endOfWeek = moment().isoWeekYear(+this.customYear).isoWeek(this.customWeek).endOf('isoweek')
        this.loadProjects()
        // this.getWeekprojects()
        // this.getAllHourEntries()
      }
    },
    getAllHourEntries () {
      let start = this.$format.formatDate(this.startOfWeek, 'DD.MM.YYYY', 'MM.DD.YYYY')
      let end = moment(this.startOfWeek).add(7,'days'). format('MM.DD.YYYY')

      let model = { start: start, end: end } // change to filter project ids , projects: this.selectedProjects.map(x => x.id)
      this.$api.execute('post', `${this.MODULE}/filter_for_calendar`, model)
        .then((response) => {
          let appHourEntries = response.data
          this.$api.execute('get', `sotasks?start=${start}&end=${end}`)
          .then((response) => {
            let list = response.data
            let sotasks = list.map((element)=> {
              element.isSoTask = true
              element.projectmemberid = this.activeUser.id
              return element
            })
            this.listOfHourEntries = [...appHourEntries, ...sotasks]
          })
          this.loadDays
        })
        .finally(()=>{
          this.reloading = false
          this.isSaveWeekProjects = true
        })
    },
    setDefaultValues (data) {
      let { list, prop } = data
      let item = list.find(x => x.isdefault)
      if (item) {
        let model = Object.assign({ ...this.hourObj }, { [prop]: item.id })
        this.hourObj = model
      }
    },
    openFormHandler (projectId, date, hoursList, event) {
      this.showNormalHourMenu = false
      event.stopPropagation()
      this.showNormalHourMenu = true
      this.positionX = event.clientX
      this.positionY = event.clientY
      // pre-select fields
      this.hourObj.id = 0
      this.hourObj.state = null
      this.hourObj.projectid = projectId
      this.hourObj.date = date
      this.normalHoursList = hoursList
    },
    getSingleRecordHandler (id) {
      this.$api.getSingleRecordHandler(`${this.MODULE}/${id}`)
        .then((result) => {
          let hour = result.data
          hour.hours = parseFloat(hour.hours).toFixed(2)
          hour.datePicker = null
          let transformNumber = { number: { list:['hours', 'findersfee'], format: 'replaceDotWithComma'}}
          hour = this.$format.formatModel(hour, transformNumber)
          let transformData = { date: { list: ['date'], from: 'YYYY.MM.DD', to: 'DD.MM.YYYY' } }
          let model = this.$format.formatModel(hour, transformData)
          if (result.data) this.hourObj = model
        })
    },
    deliverHoursHandler () {
      let self = this
      let hours = this.$format.cloneVariable(this.listOfHourEntries)
      hours = hours.filter(x => x.state === CONSTANTS.NOT_DELIVERED)
      let hourIds = hours.map(x => x.id)
      let model = { ids: hourIds, parameters: { state: CONSTANTS.DELIVERED } }
      if (this.$format.isArrayHasData(hourIds)) {
        this.$api.execute('put', `${this.MODULE}/bulk_update`, model)
          .then((response) => {
            this.getAllHourEntries()
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.timer.deliveredSuccessfully') })
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.timer.noHours') })
    },
    getHoursSum (hours) {
      return this.$format.getSumBy(hours, x => x.hours)
    },
    getWeekTotalHours () {
      let totalHours = 0
      this.totalHours.forEach(hours => {
        totalHours += this.$format.getSumBy(hours, x => x.hours)
      });
      return parseFloat(totalHours).toFixed(2)
    },
    getStatusColorHandler (hourList) {
      if (hourList.some(item => item.isSoTask)) return 'so_task'
      else if (hourList.some(item => item.state === CONSTANTS.NOT_DELIVERED)) return 'not_delivered'
      else if (hourList.some(item => item.state === CONSTANTS.NOT_APPROVED)) return 'not_approved'
      else if (hourList.some(item => item.state === CONSTANTS.DELIVERED)) return 'delivered'
      else if (hourList.some(item => item.state === CONSTANTS.APPROVED)) return 'approved'
    },
    setValuesInLocalStorage (week) {
      window.localStorage.setItem('stray_vyrje_weekno', week.isoWeek())
      window.localStorage.setItem('stray_vyrje_year', week.isoWeekYear())
    },
    unCheckSelectedProject(id) {
      let selectedProjectIds = this.selectedProjects.map(x => x.id) || []
      selectedProjectIds = selectedProjectIds.filter(x => x !== id)
      this.updateWeekProjects(selectedProjectIds)
    },
    updateWeekProjects (projectIds) {
      this.$api.execute('post', `/weekprojects?year=${this.customYear}&week=${this.customWeek}`, { ids: projectIds })
        .then((response) => {
          this.loadProjects()
          // this.getWeekprojects()
        })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('closeForm')
    this.$eventBus.$off('saveForm')
    this.$eventBus.$off('editSingleEntry')
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('getAllHourLogs')
  },
}
</script>
<style scoped>
.bordered--table table, .bordered--table table thead tr, .bordered--table table tbody tr {
  border: 1px solid rgba(0,0,0,0.12);
}
.bordered--table table thead th, .bordered--table table tbody tr td {
  border-right: 1px solid rgba(0,0,0,0.12);
}
.reduceHeight {
  height: 10px;
}
.delivered {
  background-color: #e0b517;
  color: white;
}
.not_delivered {
  background-color: lightgray !important
}
.not_approved {
  background-color: #ea1616;
  color: white;
}
.so_task {
  background-color: #0095ff !important;
  color: white;
}
.approved {
  background-color: rgba(86, 177, 62, 0.65);
  color: white;
}
.today_color {
  background-color: #0095ff !important;
}
.holiday_color {
  background-color: yellow !important;
}
 /* Scroll of two tbody ====>*/
tbody.set-scroll {
    display:block;
    max-height:65vh;
    overflow:auto;
}
thead.set-scroll, tbody.set-scroll tr, tbody.total-hours-row tr {
    display:table;
    width:100%;
    table-layout:fixed;/* even columns width , fix width of table too*/
}
tbody.total-hours-row {
  display:block;
}
.hourlog-table tbody tr td, thead th {
  border-bottom: none !important;
}
.hourlog-table thead th {
  box-shadow: none !important;
}
.hourlog-table tbody, thead {
  border: thin solid rgba(0, 0, 0, 0.12);
}
.hourlog-table tbody tr {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.hourlog-table tbody tr td, thead th {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
@media (min-width: 878px) and (max-width: 1024px) {
 .custom-size {
   font-size: 1rem;
 }
}
@media (min-width: 768px) and (max-width: 877px) {
 .custom-size {
   font-size: .85rem;
 }
}
@media (min-width: 481px) and (max-width: 767px) {
  .custom-size {
   font-size: .75rem;
 }
}
</style>
